import React from 'react';
import { Button } from 'antd';
import UserList from './list';
import CommonListsIndex from '../../../components/CommonLists/index';
import UserAdd from './add';

class UserConfig extends CommonListsIndex {
  constructor() {
    super();
    this.api = 'usersConfig';
    this.addComponent = UserAdd;
    this.editComponent = UserAdd;
    this.listsComponent = UserList;
  }
  componentDidMount() {
    this.freshQueryList();
  }

  freshQueryList = () => {
    this.queryList({});
  };
  render() {
    const ListsComponent = this.listsComponent;
    return (
      <div>
        <div className="tantuer-op">
          <Button type="primary" icon="plus" onClick={this.add}>
            新增
          </Button>
        </div>

        <ListsComponent
          data={this.state.listsData}
          edit={this.edit}
          queryList={this.freshQueryList}
        />
      </div>
    );
  }
}

export default UserConfig;
